import { TOGGLE_EBRIEFING_MODAL } from '../actions/ebriefingModal';

const initialState = {
  isOpen: false,
};

export default (state, action) => {
  if (typeof state === 'undefined') {
    return initialState;
  }

  switch (action.type) {
    case TOGGLE_EBRIEFING_MODAL:
      return {
        ...state,
        isOpen: !state.isOpen,
      };
    /* istanbul ignore next -- @preserve */
    default:
      return state;
  }
};
